import { USER_AUTH, SYS_BUTTON_AUTH } from '@/store/mutation-types'

const hasPermission = {
  install(Vue, options) {
    Vue.directive('has', {
      inserted: (el, binding, vnode) => {
        //节点权限处理，如果命中则不进行全局权限处理
        if (!filterNodePermission(el, binding, vnode)) {
          filterGlobalPermission(el, binding, vnode)
        }
      }
    })
  }
}

/**
 * 流程节点权限控制
 */
export function filterNodePermission(el, binding, vnode) {
  let permissionList = []
  try {
    let obj = vnode.context.$props.formData
    if (obj) {
      let bpmList = obj.permissionList
      for (let bpm of bpmList) {
        if (bpm.type != '2') {
          permissionList.push(bpm)
        }
      }
    } else {
      return false
    }
  } catch (e) {}
  if (permissionList === null || permissionList === '' || permissionList === undefined || permissionList.length <= 0) {
    //el.parentNode.removeChild(el)
    return false
  }

  let permissions = []
  for (let item of permissionList) {
    if (item.type != '2') {
      permissions.push(item.action)
    }
  }

  if (!permissions.includes(binding.value)) {
    //el.parentNode.removeChild(el)
    return false
  } else {
    for (let item2 of permissionList) {
      if (binding.value === item2.action) {
        return true
      }
    }
  }
  return false
}

/**
 * 全局权限控制
 */
export function filterGlobalPermission(el, binding, vnode) {
  let loginUser = JSON.parse(localStorage['pro__Login_Userinfo']).value
  if (loginUser.editableFlag && loginUser.editableFlag == '1') {
    return
  }

  //let permissionList = [];
  //let allPermissionList = [];

  ////let authList = Vue.ls.get(USER_AUTH);
  let authList = JSON.parse(sessionStorage.getItem(USER_AUTH) || "[]");
  //for (let auth of authList) {
  //  if (auth.type != '2') {
  //    permissionList.push(auth);
  //  }
  //}

  //let allAuthList = JSON.parse(sessionStorage.getItem(SYS_BUTTON_AUTH) || '[]')
  //for (let gauth of allAuthList) {
  //  if (gauth.type != '2') {
  //    allPermissionList.push(gauth);
  //  }
  //}
  ////设置全局配置是否有命中
  //let invalidFlag = false; //无效命中
  //if (allPermissionList != null && allPermissionList != "" && allPermissionList != undefined && allPermissionList.length > 0) {
  //  for (let itemG of allPermissionList) {
  //    if (binding.value === itemG.action) {
  //      if (itemG.status == '0') {
  //        invalidFlag = true;
  //        break;
  //      }
  //    }
  //  }
  //}
  //if (invalidFlag) {
  //  return;
  //}
  //if (permissionList === null || permissionList === "" || permissionList === undefined || permissionList.length <= 0) {
  //  el.parentNode.removeChild(el);
  //  return;
  //}
  //let permissions = [];
  //for (let item of permissionList) {
  //  if (item.type != '2') {
  //    permissions.push(item.action);
  //  }
  //}

  //if (!permissions.includes(binding.value)) {
  if (XEUtils.filter(authList, r => r.action == binding.value).length == 0) {
    if (el.tagName == 'A') {
      var a = document.createElement('a')
      a.innerHTML = el.text
      a.style.color = '#00000040'
      a.style.cursor = 'default'
      a.classList.add('a-no-wave')
      el.parentNode.insertBefore(a, el)
    } else if (el.tagName == 'BUTTON') {
      var button = el.cloneNode(true)
      button.disabled = true
      el.parentNode.insertBefore(button, el)
    } else if (el.classList.contains('ant-divider')) {
      return
    }

    el.parentNode.removeChild(el)
  }
}

export default hasPermission
